//
//
//
//
//
//
//
//
//
//
//


import { getFilterIcon } from './ServerFilterIcons.js'

export default {
  props: {
    type: {
      type: String,
      default: null
    },
    filter: {
      type: Object,
      default: () => {}
    }
  },
  data: function () {
    return {
      getFilterIcon: getFilterIcon
    }
  }
}
